import { Pencil, Trash2, Users } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { formatCurrency } from '../../lib/currency';
import type { Expense, Participant, CurrencyCode } from '../../types';

interface ExpenseCardProps {
  expense: Expense;
  participants: Participant[];
  currency: CurrencyCode;
  onEdit: () => void;
  onDelete: () => void;
}

export function ExpenseCard({
  expense,
  participants,
  currency,
  onEdit,
  onDelete,
}: ExpenseCardProps) {
  const payer = participants.find((p) => p.id === expense.paidById);
  const involvedCount = expense.participantIds.length;
  const splitAmount = expense.amount / involvedCount;

  return (
    <Card>
      <CardContent className="py-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <p className="font-medium truncate">{expense.description}</p>
            <p className="text-sm text-muted-foreground">
              Pagó {payer?.name || 'Desconocido'}
            </p>
            <div className="flex items-center gap-1 text-xs text-muted-foreground mt-1">
              <Users className="h-3 w-3" />
              <span>
                {involvedCount} personas · {formatCurrency(splitAmount, currency)} c/u
              </span>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <span className="font-semibold">{formatCurrency(expense.amount, currency)}</span>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 text-muted-foreground hover:text-primary shrink-0"
              onClick={onEdit}
            >
              <Pencil className="h-4 w-4" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 text-muted-foreground hover:text-destructive shrink-0"
              onClick={onDelete}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
